import {config, global} from "../../../appContext";
import {IFormData} from "./index";
import {REDIRECTING_MESSAGE} from "../../../constants/Language";
import method_idportenHtml from './method-idporten.html?raw';

export let template = method_idportenHtml;

export class viewModel {

    private reqGetCompanyLogin = global.getPromiseRequest('getcompanylogin');

    constructor(private params: IFormData) {
    }
    
    protected onSubmit(): void {
        this.params.isReady(false);
        this.params.messageData({message: REDIRECTING_MESSAGE});
        const orgnr = this.params.selectedOrg().orgnr;
        const redirect = document.location.origin + '/#/resetownpassword';
        const url = `${config.getUrlIdentityHub()}login/idporten-${orgnr}` + '/' + encodeURIComponent(redirect);
        window.location.href = url;
    }

    dispose() {
        this.reqGetCompanyLogin.abort();
    }

}
